import { Injectable } from '@angular/core';
import { FantasyHistoryService } from './fantasy-history.service';

@Injectable({ providedIn: 'root' })
export class FantasyHistoryResolver {
  constructor(private fantasyHistoryService: FantasyHistoryService) {}

  resolve() {
    return this.fantasyHistoryService.fetchFantasyHistory();
  }
}
